const FFPROBE = {
	install (Vue, options) {
		Vue.prototype.$ffprobe = {

			ffprobeCleaner (probe) {
				if (!(probe instanceof Object)) return false
				let cleaned = {
					format: null,
					streams: []
				}
				if (probe.result) probe = probe.result
				cleaned.format = probe.format
				if (probe.streams) {
					for (let i = 0; i < probe.streams.length; i++) {
						if (probe.streams[i].hasOwnProperty('codec_type') &&
							probe.streams[i].hasOwnProperty('index')) {
							cleaned.streams.push(probe.streams[i])
						}
						if (probe.streams[i].hasOwnProperty('nb_streams') &&
							probe.streams[i].hasOwnProperty('probe_score')) {
							cleaned.format = probe.streams[i]
						}
					}
				}
				return cleaned
			}

		}
	}
}

export default FFPROBE



// WEBPACK FOOTER //
// ./src/plugins/ffprobe.js